<template>
  <div class="screen-full">
    <div v-show="!isFullscreen" @click="handleFullScreen"></div>
    <div v-show="isFullscreen" @click="handleFullScreen"></div>
  </div>
</template>

<script>
import screenfull from "screenfull";
import {Toast} from "../../utils/tools";
export default {
  name: "screenfull",
  data() {
    return {
      isFullscreen: false, //是否全屏
    };
  },
  mounted() {
    this.init();
    window.onresize = () => {
      // 全屏下监控是否按键了ESC
      if (!this.checkFull()) {
        // 全屏下按键esc后要执行的动作
        this.isFullscreen = false
      }
    }
  },
  beforeDestroy() {
    this.destroy();
  },
  methods: {
    /**
     * 是否全屏并按键ESC键的方法
     */
    checkFull() {
      var isFull = document.fullscreenEnabled || window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled
      // to fix : false || undefined == undefined
      if (isFull === undefined) {
        isFull = false
      }
      return isFull
    },
    handleFullScreen() {
      if (!screenfull.isEnabled) {
        Toast.info("Your browser version is too low to support full screen browsing",this);
        return false;
      }
      screenfull.toggle();
    },
    change() {
      this.isFullscreen = screenfull.isFullscreen;
    },
    init() {
      if (screenfull.isEnabled) {
        screenfull.on("change", this.change);
      }
    },
    destroy() {
      if (screenfull.isEnabled) {
        screenfull.off("change", this.change);
      }
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widget/screenfull.vue